const KEY = 'couplespace:recent-pages';
const MAX_RECENT = 8;
export const RECENT_SIDEBAR_LIMIT = 5;

const CHANGED_EVENT = 'couplespace:recent-pages-changed';

export type RecentPage = {
  id: string;
  title: string;
  type: 'page' | 'database';
  visitedAt?: string;
};

export function getRecentPages(): RecentPage[] {
  if (typeof localStorage === 'undefined') {
    return [];
  }
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw) as RecentPage[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function getRecentPagesForSidebar(): RecentPage[] {
  return getRecentPages().slice(0, RECENT_SIDEBAR_LIMIT);
}

function notifyRecentPagesChanged(): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(new Event(CHANGED_EVENT));
}

/** Re-render sidebar (and other listeners) when recents change. */
export function subscribeRecentPages(listener: () => void): () => void {
  if (typeof window === 'undefined') {
    return () => {};
  }
  window.addEventListener(CHANGED_EVENT, listener);
  return () => window.removeEventListener(CHANGED_EVENT, listener);
}

export function pushRecentPage(page: RecentPage): void {
  if (typeof localStorage === 'undefined') {
    return;
  }
  const without = getRecentPages().filter((entry) => entry.id !== page.id);
  const next = [
    { ...page, visitedAt: new Date().toISOString() },
    ...without.map((entry) => ({
      ...entry,
      visitedAt: entry.visitedAt,
    })),
  ].slice(0, MAX_RECENT);
  localStorage.setItem(KEY, JSON.stringify(next));
  notifyRecentPagesChanged();
}

export function removeRecentPage(pageId: string): void {
  if (typeof localStorage === 'undefined') {
    return;
  }
  const next = getRecentPages().filter((entry) => entry.id !== pageId);
  if (next.length === getRecentPages().length) {
    return;
  }
  localStorage.setItem(KEY, JSON.stringify(next));
  notifyRecentPagesChanged();
}

export function clearRecentPages(): void {
  if (typeof localStorage === 'undefined') {
    return;
  }
  localStorage.removeItem(KEY);
  notifyRecentPagesChanged();
}
